'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var $ = require('jquery');
var moment = require('moment-timezone');
var parse = require('parse-color');
var maps = require('../../utilities/maps').default;
var LocationSelectionEvents = require('../../../analytics/location-selection-events').default;
var template = require('./templates/infowindow.hbs');
var urlHelpers = require('../../utilities/urls').default;
var LanguagesCollection = require('../../collections/languages').default;

export default Backbone.View.extend({

  defaultPinColour: 'rgb(249,113,107)',
  className: 'location-map',
  events: {
    'click .tabs > ul a': 'onClickTab',
  },
  ui: {
    searchBox: '.location-search-box',
  },

  initialize: function (options) {
    this.appointment = options.appointment;
    this.markers = options.markers;
    this.map = null;
    this.pins = {};
    this.dots = {};
    this.languages = new LanguagesCollection(window.LANGUAGES);
    this.latitude = 52.1333;
    this.longitude = -106.6833;
    this.location = null;
    this.setCenterToFirstModelLocation();
    this.fetchWaitTimes = options.fetchWaitTimes;
    this.waitTimes = options.waitTimes;
    this.shouldShowWaitTime = options.shouldShowWaitTime;

    this.infoWindow = new maps.InfoWindow();
    maps.event.addListener(this.infoWindow, 'closeclick', _.bind(this.onCloseInfoWindow, this));

    this.listenTo(this.collection, 'reset', this.onCollectionReset);
  },

  onSearchByLocation: function () {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        _.bind(this.onGeolocationSuccess, this),
        _.bind(this.onGeolocationError, this)
      );
    }
  },

  onGeolocationSuccess: function (position) {
    this.trigger('geolocation-success');
    this.generateTimezoneCookie(position.coords.latitude, position.coords.longitude);
    this.setCenter(position.coords.latitude, position.coords.longitude);
    this.collection.setPosition(position.coords.latitude, position.coords.longitude);

    const data = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    const urlParam = urlHelpers.getParam('within');

    if (this.appointment.has('service_id')) {
      data.preferred_service_id = this.appointment.get('service_id');
    }

    if (this.appointment.has('staff_id')) {
      data.preferred_staff_id = this.appointment.get('staff_id');
    }

    if (urlParam) {
      data.within = urlParam;
    }

    data.lang = this.languages.getCurrent();

    this.collection.fetch({
      data: data,
      reset: true,
      success: (collection) => {
        this.trigger('renderLocationCountMessage');
        this.fetchWaitTimes(collection);
      },
    });
  },

  onGeolocationError: function () {
    this.trigger('geolocation-error');
  },

  generateTimezoneCookie: function (lat, lng) {
    var timezoneUrl = "https://maps.googleapis.com/maps/api/timezone/json?location=" +
      lat + "," + lng + "&timestamp=" + moment().format('X') + "&key=" + window.SETTINGS.google_api_key;

    $.ajax({
      'url': timezoneUrl,
    }).done(function (response) {
      if (response.status == "OK") {
        window.localStorage.setItem('timezone', response.timeZoneId);
      }
    });

  },

  renderMap: function () {
    this.map = new maps.Map(this.$el[0], this.getMapOptions());
    maps.event.addListenerOnce(this.map, 'idle', _.bind(this.onMapIdle, this));
    this.setCenterToFirstModelLocation();
    this.addPinsToMap();
  },

  refreshMap: function () {
    maps.event.trigger(this.map, 'resize');
  },

  getMapOptions: function () {
    var mapOptions = {
      center: {
        'lat': this.latitude,
        'lng': this.longitude,
      },
      zoom: 3,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    };

    return mapOptions;
  },

  onCollectionReset: function () {
    this.setCenterToFirstModelLocation();
    this.removePins();
    this.addPinsToMap();
  },

  addDotsToMap: function () {
    if (!this.map) return;
    var self = this;
    this.markers.each(function (marker) {
      self.addDot(marker);
    });
  },

  addDot: function (marker) {
    var dot = new maps.Marker({
      position: {
        'lat': parseFloat(marker.get('lat')),
        'lng': parseFloat(marker.get('lng')),
      },
      map: this.map,
      optimize: false,
    });

    var color = parse(window.THEME.pin_colour);
    if (color.rgb) {
      dot.setIcon(this.createDot(color));
    } else {
      dot.setIcon(this.createDot(parse(this.defaultPinColour)));
    }

    this.dots[Object.keys(this.dots).length] = dot;
  },

  createDot: function (colour) {
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<?xml version="1.0"?><svg width="24" height="30" viewBox="0 0 24 30" xmlns="http://www.w3.org/2000/svg"><circle fill="rgb(' + colour.rgb + ')" cx="12.065" cy="11.413" r="5.543"/></svg>'),
      scaledSize: new google.maps.Size(24, 30)
    };
  },

  addPinsToMap: function () {
    if (!this.map || this.appointment.isPrivate()) return;
    var self = this;

    var bounds = new maps.LatLngBounds();

    this.collection.each(function (location) {
      if (location.get('virtual') !== true) {
        var mapsLocation = new maps.LatLng(
            parseFloat(location.get('latitude')),
            parseFloat(location.get('longitude')));
        bounds.extend(mapsLocation);
        self.addPin(location);
      }
    });

    if (window.SETTINGS.auto_location_search && !$(this.ui.searchBox).val()) {
      this.map.fitBounds(bounds);
    }
  },

  removeDots: function() {
    for (var i in this.dots) {
      this.dots[i].setMap(null);
    }
    this.dots = {};
  },

  removePins: function () {
    for (var i in this.pins) {
      this.pins[i].setMap(null);
    }
    this.pins = {};
  },

  addPin: function (location) {
    var marker = new maps.Marker({
      position: {
        'lat': parseFloat(location.get('latitude')),
        'lng': parseFloat(location.get('longitude')),
      },
      map: this.map,
      optimize: false,
      title: location.get('name'),
    });

    var color = parse(window.THEME.pin_colour);
    if (color.rgb) {
      marker.setIcon(this.createPin(color));
    }

    maps.event.addListener(marker, 'click', _.bind(this.onClickMarker, this, location));

    this.pins[location.id] = marker;
  },

  createPin: function (colour) {
    var centerColour = this.calculateCenterColour(colour);

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<?xml version="1.0"?><svg width="24" height="30" viewBox="0 0 24 30" xmlns="http://www.w3.org/2000/svg"><title>Slice 1</title><g fill-rule="nonzero" fill="none"><path d="M11.74 0C5.282 0 0 5.087 0 11.348c0 2.478.848 4.826 2.348 6.782l8.87 11.61c.195.26.652.325.912.13l.13-.13 8.87-11.61c1.5-1.956 2.348-4.304 2.348-6.782C23.478 5.088 18.196 0 11.738 0z" fill="rgb(' + colour.rgb + ')"/><circle fill="' + centerColour + '" cx="12.065" cy="11.413" r="5.543"/></g></svg>'),
      scaledSize: new google.maps.Size(24, 30)
    };
  },

  calculateCenterColour(colour) {
    var c = colour.rgb.map((col) => {
      col = col / 255;
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    return (L > 0.179) ? 'rgb(0,0,0)' : 'rgb(255,255,255)';
  },

  onClickMarker: function (location) {
    LocationSelectionEvents.trackClick('Map');
    this.trigger('change:location', location);
    location.fromMapView = true;
    this.trigger('showLocationDetails', location);
  },

  onCloseInfoWindow: function () {
    this.trigger('change:location', null);
  },

  onMapIdle: function () {
    document.getElementsByTagName('iframe')[0].title = "Google Maps";
  },

  toggleInfoWindow: function () {
    if (this.location && !this.location.get('virtual')) {
      this.showInfoWindow(this.location);
    } else {
      this.hideInfoWindow();
    }
  },

  showInfoWindow: function (location) {
    this.infoWindow.setContent(template(this.getInfoWindowContext(location)));
    this.infoWindow.open(this.map, this.pins[location.id]);
  },

  hideInfoWindow: function () {
    this.infoWindow.close();
  },

  setCenterToFirstModelLocation: function() {
    if (this.collection.models.length && this.map) {
      this.setBounds();
    } else {
      this.setCenterToLocation(this.collection.at(0));
    }
  },

  setBounds: function() {
    let bounds = new google.maps.LatLngBounds();
    for (let i = 0; i < this.collection.models.length; i++) {
      if (!this.collection.models[i].attributes.virtual) {
        bounds.extend({
          lat: this.collection.models[i].attributes.latitude,
          lng: this.collection.models[i].attributes.longitude,
        });
      }
    }

    if (bounds.isEmpty()) {
      return;
    }

    this.map.fitBounds(bounds);
    if (this.map.getZoom() > 15) {
      this.map.setZoom(15);
    }
  },

  setCenterToLocation: function (location) {
    if (!location) return;
    if (location.get('virtual')) return;
    this.setCenter(parseFloat(location.get('latitude')), parseFloat(location.get('longitude')));
  },

  setCenter: function (latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;

    if (!this.map) return;

    this.map.setCenter({
      'lat': latitude,
      'lng': longitude,
    });
    this.map.setZoom(11);
  },

  setLocation: function (location) {
    this.location = location;
    this.setCenterToLocation(this.location);
    this.toggleInfoWindow();
  },

  onClickTab: function (evt) {
    evt.preventDefault();

    var $el = $(evt.currentTarget);
    var selector = $el.attr('href');

    this.$('.tabs li').removeClass('active');
    $el.parent().addClass('active');

    this.$('.tabs > div').removeClass('active');
    this.$(selector).addClass('active');
  },

  getInfoWindowContext: function (location) {
    const json = location.toJSON();
    const waitTime = this.waitTimes.get(location.id);

    json.showWaitTime = this.shouldShowWaitTime && location.shouldShowWaitTime();

    if (json.showWaitTime && waitTime) {
      json.waitTime = waitTime.get('waitTime');
    }

    return json;
  },

});
